import moment from 'moment';

export default value => {
  return moment(value * 1000).fromNow();
};
